<div class="update-notification-container" *ngIf="visible" @slideIn>
  <div class="update-notification-card">
    <!-- Close Button -->
    <button class="close-btn" (click)="close()" type="button" aria-label="Close">
      <i class="fa-light fa-xmark"></i>
    </button>

    <!-- Icon Container mit Animation -->
    <div class="icon-container">
      <div class="icon-wrapper">
        <i class="fa-light fa-arrow-down-to-line"></i>
      </div>
      <div class="icon-glow"></div>
    </div>

    <!-- Content -->
    <div class="notification-content">
      <h3 class="notification-title">
        {{ 'UPDATE_AVAILABLE_TITLE' | translate }}
      </h3>
      <p class="notification-message">
        {{ 'UPDATE_AVAILABLE_MESSAGE' | translate }}
      </p>
    </div>

    <!-- Action Buttons -->
    <div class="notification-actions">
      <button
        class="upd-btn upd-btn--secondary"
        (click)="handleUpdateLater()"
        type="button">
        <span class="upd-btn-content">
          <i class="fa-light fa-clock"></i>
          {{ 'UPDATE_LATER_BUTTON' | translate }}
        </span>
      </button>

      <button
        class="upd-btn upd-btn--primary"
        (click)="handleUpdateNow()"
        type="button">
        <span class="upd-btn-content">
          <i class="fa-light fa-refresh"></i>
          {{ 'UPDATE_NOW_BUTTON' | translate }}
        </span>
      </button>
    </div>

    <!-- Progress Bar Animation -->
    <div class="progress-indicator">
      <div class="progress-bar"></div>
    </div>
  </div>
</div>
